import React from 'react'
import "./My_rewards_user_list.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBitcoinSign, faSliders } from '@fortawesome/free-solid-svg-icons'

function My_rewards_user_list() {
    return (
        <>
            <section className='My_rewards_user_list section_margin  '>
                <div className="profile_tabs_and_content">
                    <div className="section_holder">
                        <div className="list_heading_holder">
                            <div className="row">
                                <div className="col-6">
                                    <div className="heading_text_holder">
                                        <h6> Coins History</h6>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="heading_text_holder">
                                        <h6 className='filter_text_holder'> Sort by: <FontAwesomeIcon icon={faSliders} /></h6>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="list_holder">
                            <FontAwesomeIcon className='bitcoin' icon={faBitcoinSign} />
                            <div className="row">
                                <div className="col-6">
                                    <div className="text_holder">
                                        <h6> 02 Coins</h6>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="text_holder">
                                        <h5 className='right_text'>12 JAN 25 | 2:30</h5>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="list_holder">
                            <FontAwesomeIcon className='bitcoin' icon={faBitcoinSign} />
                            <div className="row">
                                <div className="col-6">
                                    <div className="text_holder">
                                        <h6>  02 Coins</h6>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="text_holder">
                                        <h5 className='right_text'>12 JAN 25 | 2:30</h5>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="list_holder">
                            <FontAwesomeIcon className='bitcoin' icon={faBitcoinSign} />
                            <div className="row">
                                <div className="col-6">
                                    <div className="text_holder">
                                        <h6>  02 Coins</h6>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="text_holder">
                                        <h5 className='right_text'>12 JAN 25 | 2:30</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}

export default My_rewards_user_list